// Identidade de uma linha cliente + proxy (templates nao tem proxy - vira "<clienteId>::")
export default function alvoId(linha) {
	return `${linha?.clienteId}::${String(linha?.proxy ?? "").trim().toLowerCase()}`;
}
